import { render, staticRenderFns } from "./add_organization_jbxx.vue?vue&type=template&id=2e0ab42f&scoped=true&"
import script from "./add_organization_jbxx.vue?vue&type=script&lang=js&"
export * from "./add_organization_jbxx.vue?vue&type=script&lang=js&"
import style0 from "./add_organization_jbxx.vue?vue&type=style&index=0&id=2e0ab42f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ab42f",
  null
  
)

export default component.exports